export enum ESelectT1CreationModalType {
  T2,
  T3,
  T4,
}

export enum ESelectT1CreationModalSearchParamKey {
  masterScheduleId = 'masterScheduleId',
  issueRole = 'issueRole',
}
